<mat-icon matTooltip="{{ 'Common.Filters.FilterNumber' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>

<mat-menu #menu="matMenu">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <form [formGroup]="filterForm" (click)="$event.stopPropagation();">
          <mat-form-field>
            <mat-label>{{ 'Common.Filters.FilterType' | translate }}</mat-label>
            <mat-select [formControl]="filterTypeControl" [value]="filterTypeControl"
              (selectionChange)="onFilterChange($event)" (click)="$event.stopPropagation();">
              @for (option of filterOptions; track option) {
                <mat-option [value]="option.value"
                  (click)="$event.stopPropagation();">
                  {{ option.translationKey | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>

    @if (this.currentFilter.value !== this.numberFilterBetween) {
      <div class="row">
        <div class="col-12">
          <form [formGroup]="singleNumberForm" (click)="$event.stopPropagation();">
            <mat-form-field>
              <mat-label>{{'Common.Filters.Number' | translate }} </mat-label>
              <input type="number" matInput [formControl]="numberSingleNumberControl"
                (click)="$event.stopPropagation();">
              </mat-form-field>
            </form>
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col-12">
            <form [formGroup]="numberBetweenForm" (click)="$event.stopPropagation();">
              <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <mat-label>{{'Common.Filters.From' | translate }} </mat-label>
                    <input type="number" matInput [formControl]="numberBetweenValueControl"
                      (click)="$event.stopPropagation();">
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field>
                      <mat-label>{{'Common.Filters.To' | translate }} </mat-label>
                      <input type="number" matInput [formControl]="numberBetweenValue2Control"
                        (click)="$event.stopPropagation();">
                      </mat-form-field>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }


          <div class="row">
            <div class="col" style="display: flex; justify-content: flex-end;">
              <mat-icon matTooltip="{{ 'Common.Filters.Cancel' | translate }}" class="cursor-pointer"
                color="primary" (click)="onCancel()">
                clear
              </mat-icon>
              <mat-icon matTooltip="{{ 'Common.Filters.RunFilter' | translate }}" class="cursor-pointer"
                color="primary" (click)="onSubmit($event)">
                check
              </mat-icon>
              @if (this.currentValue | async) {
                <mat-icon matTooltip="{{ 'Common.Filters.Clear' | translate }}" class="cursor-pointer" color="primary"
                  (click)="onClear()">
                  delete
                </mat-icon>
              }
            </div>
          </div>
        </div>
      </mat-menu>
